<template>
  <div id="bets-summary">
    <div class="summary-item summary-margin">
      <span class="summary-title">Expected Margin:</span>
      <span class="summary-value">
        {{ expectedMargin() }}
      </span>
    </div>
    <div class="summary-item summary-ev">
      <span class="summary-title">Total EV:</span>
      <span class="summary-value">
        {{ totalEV() }}
      </span>
    </div>
    <div class="summary-item summary-profit">
      <span class="summary-title">Total Profit:</span>
      <span class="summary-value">
        {{ totalProfit() }}
      </span>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "BetSummary",
  props: ["bets"],
  methods: {
    expectedMargin() {
      let totalEV = 0;
      let totalStake = 0;
      for (const b of this.bets) {
        if (b.state === "FINAL") {
          totalStake += b.stake;
          totalEV += b.result.ev;
        }
      }

      const avg = totalStake ? (100 * totalEV) / totalStake : 0;
      return avg.toFixed(2) + " %";
    },
    totalProfit() {
      const profit = _.sumBy(this.bets, b => {
        return b.result ? b.result.bet_return - b.stake : 0;
      });
      return "$ " + profit.toFixed(2);
    },
    totalEV() {
      const ev = _.sumBy(this.bets, b => {
        return b.result ? b.result.ev : 0;
      });
      return "$ " + ev.toFixed(2);
    }
  }
};
</script>

<style lang="scss">
#bets-summary {
  height: 80px;
  display: table-cell;
  vertical-align: middle;

  .summary-margin {
    min-width: 250px;
  }
  .summary-ev {
    min-width: 190px;
  }

  .summary-profit {
    min-width: 190px;
  }

  .summary-item {
    margin-left: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    display: inline-block;
  }

  .summary-title {
    font-weight: 500;
    font-size: 1em;
  }

  .summary-value {
    font-size: 1em;
    margin-left: 10px;
  }
}
</style>
